

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop, Watch} from "vue-property-decorator";
  import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
  import {IErrors} from "@/model/IErrors";

  @Component({})
  export default class SPInvoicing extends Vue {

    @Prop()
    protected provider!: IServiceProvider;
    @Prop()
    protected errors!: IErrors;
    @Prop()
    protected editing!: boolean;
    @Prop()
    protected viewing!: boolean;
    @Prop()
    protected disabled!: boolean;

    protected get showDetails(): boolean {
      return this.editing || this.viewing;
    }

  }

